import ResponseHelper from './response-helper';

/**
 * Manages requests to webservice related to questionnaires.
 * Returns with `code = 0` are considered sucessfull.
 */

export default (axios) => ({
  /**
   * Loads the quesionnaire by id
   * @param {number} id
   * @param {string} utoken
   * @returns {Promise<{code: Number, message: String, data: {} }>}
   */
  loadQuestionnaire(id, utoken) {
    return axios({
      method: 'get',
      url: `questionnaires/user/${id}`,
      headers: {
        utoken
      }
    })
      .then(function (response) {
        const d = response.data;
        return Promise.resolve({
          data: {
            description: d.description,
            endTime: d.endTime,
            grade: d.grade,
            id: d.id,
            instructions: d.instructions,
            maxDuration: d.maxDuration,
            maxRetries: d.maxRetries,
            minimumGrade: d.minimumGrade,
            numberOfQuestions: d.numberOfQuestions,
            questionnaireId: d.questionnaireId,
            questionnaireType: d.questionnaireType,
            startTime: d.startTime,
            title: d.title,
            userGrade: d.userGrade
          },
          code: 0, // Code = 0 means user is logged in
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * update the quesionnaire
   * @param {number} id
   * @param {object} data
   * @param {string} utoken
   * @returns {Promise<{code: Number, message: String, data: {} }>}
   */
  updateQuestionnaire(id, data, utoken) {
    return axios({
      method: 'put',
      url: `questionnaires/user/${id}`,
      data,
      headers: {
        utoken
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response,
          code: 0, // Code = 0 means user is logged in
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * start the quesionnaire
   * @param {number} id
   * @param {string} utoken
   * @param {number} contentId content id
   * @returns {Promise<{code: Number, message: String, data: {} }>}
   */
  startQuestionnaire(id, utoken, contentId) {
    return axios({
      method: 'get',
      url: `questionnaires/user/${id}/content/${contentId}/start`,
      headers: {
        utoken
      }
    })
      .then(function (response) {
        const d = response.data;
        return Promise.resolve({
          data: {
            description: d.description,
            endTime: d.endTime,
            grade: d.grade,
            id: d.id,
            instructions: d.instructions,
            maxDuration: d.maxDuration,
            maxRetries: d.maxRetries,
            minimumGrade: d.minimumGrade,
            numberOfQuestions: d.numberOfQuestions,
            sections: d.sections,
            questionnaireId: d.questionnaireId,
            questionnaireType: d.questionnaireType,
            startTime: d.startTime,
            title: d.title,
            userGrade: d.userGrade
          },
          code: 0, // Code = 0 means user is logged in
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * get questionnaire status
   * @param {number} questionnaireId
   * @param {string} utoken
   * @param {number} contentId content id
   * @returns {Promise<{code: Number, message: String, data: {} }>}
   */
  getQuestionnaireStatus(questionnaireId, contentId, utoken) {
    return axios({
      method: 'get',
      url: `questionnaires/user/${questionnaireId}/content/${contentId}/status`,
      headers: {
        utoken
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response,
          code: 0,
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  }
});
